import {
  FETCH_SCREENER_FAILURE,
  FETCH_SCREENER_REQUEST,
  FETCH_SCREENER_SUCCESS,
  FETCH_FOOTNOTESLABEL_SUCCESS,
  FETCH_FOOTNOTESLABEL_FAILURE,
  REDUCE_ARGS,
  UPDATE_SORT,
  UPDATE_RESULT_LIMIT,
  UPDATE_DISTRIBUTIONS_PERIOD,
  REDUCE_ARGS_DISTRIBUTIONS,
  FETCH_DISCLOSURES_BULK_REQUEST,
  FETCH_DISCLOSURES_BULK_SUCCESS,
  FETCH_DISCLOSURES_BULK_FAILURE
} from './action-types';
import { screenerAPI, getFootNotesLabel, getProfileFootnotesBulk } from '../../../hooks/api';

import { client, internalApiClient } from '../../../services/screener-service';
import getScreenerArgs from './screener-args';
import getScreenType from './screens';
import { CHANNELS } from '../../../shared/screener-constants';

export const fetchFootnotesLabelSuccess = data => {
  return {
    type: FETCH_FOOTNOTESLABEL_SUCCESS,
    payload: data
  };
};

export const fetchFootnotesLabelFailure = data => {
  return {
    type: FETCH_FOOTNOTESLABEL_FAILURE
  };
};

export const fetchScreenerRequest = () => {
  return {
    type: FETCH_SCREENER_REQUEST
  };
};

export const fetchScreenerSuccess = (
  data,
  channel,
  pagination,
  participantPlansAndTickers,
  searchedPlanNumber,
  subPlanNumber
) => {
  return {
    type: FETCH_SCREENER_SUCCESS,
    payload: data,
    channel,
    pagination,
    participantPlansAndTickers,
    searchedPlanNumber,
    subPlanNumber
  };
};

export const fetchScreenerFailure = error => {
  return {
    type: FETCH_SCREENER_FAILURE,
    payload: error
  };
};

export const reduceArgs = (channel, defaultView, bluetagcharacteristic) => {
  return {
    type: REDUCE_ARGS,
    channel,
    defaultView,
    bluetagcharacteristic
  };
};

export const reduceArgsDistributions = channel => {
  return {
    type: REDUCE_ARGS_DISTRIBUTIONS,
    channel
  };
};

export const updateSort = ({ sortBy, sortDirection }, performanceQuarterly, showSalesCharge) => {
  return {
    type: UPDATE_SORT,
    sortBy,
    sortDirection,
    showSalesCharge,
    performanceQuarterly
  };
};

export const updateResultLimit = () => {
  return {
    type: UPDATE_RESULT_LIMIT
  };
};

export const updateDistributionsPeriod = (distributionDates, distPeriod) => {
  return {
    type: UPDATE_DISTRIBUTIONS_PERIOD,
    distributionDates,
    distPeriod
  };
};

export const fetchScreenerData = ({
  yyy,
  channel,
  sortingState,
  distributions,
  performanceQuarterly,
  defaultView,
  bluetagcharacteristic
}) => {
  return async (dispatch, getState) => {
    dispatch(fetchScreenerRequest());
    if (distributions) {
      dispatch(reduceArgsDistributions(channel));
    } else {
      dispatch(reduceArgs(channel, defaultView, bluetagcharacteristic));
    }

    const state = getState();
    const planXids = state.filterReducer.filters.planXids;
    const moreThan500PlanResults = planXids.length > 500;
    const isSearchedPlanInContext = state.filterReducer.inputs.isSearchedPlanInContext;
    const searchedPlanNumber = state.filterReducer.inputs.searchedPlanNumber;
    const participantPlansAndTickers = state.filterReducer.participantPlansAndTickers;
    const subPlanNumber = state.filterReducer.inputs.subPlan;
    const screenId = getScreenType(channel, isSearchedPlanInContext);
    let offset = 0;
    let screenerArgs = getScreenerArgs(
      state.filterReducer.args.appliedFilters,
      state.filterReducer.args.fundTypeArgs,
      offset
    );

    try {
      const internalService = await internalApiClient(yyy, channel);
      const footnotesResult = await getFootNotesLabel({ client: internalService });
      dispatch(fetchFootnotesLabelSuccess(footnotesResult));
    } catch (error) {
      dispatch(fetchFootnotesLabelFailure(error.message));
    }

    try {
      const service = await client(yyy, channel);
      let inputs = {
        client: service,
        screenId,
        params: screenerArgs
      };

      let output = [];
      const response = await screenerAPI(inputs);
      if (!response.items) {
        throw new Error('No Screener rows');
      }
      offset += 500;
      if ((channel === CHANNELS.PUBLIC && !isSearchedPlanInContext) || moreThan500PlanResults) {
        while (offset < response.pagination.totalItems) {
          screenerArgs = getScreenerArgs(
            state.filterReducer.args.appliedFilters,
            state.filterReducer.args.fundTypeArgs,
            offset
          );
          offset += 500;
          inputs = {
            client: service,
            screenId,
            params: screenerArgs
          };
          const result = await screenerAPI(inputs);
          if (!result.items) {
            throw new Error('No Screener rows');
          }
          output = [...result.items, ...output];
          if (offset >= response.pagination.totalItems) {
            dispatch(
              fetchScreenerSuccess(
                output,
                channel,
                response.pagination,
                participantPlansAndTickers,
                searchedPlanNumber,
                subPlanNumber
              )
            );
            dispatch(updateSort(sortingState, performanceQuarterly));
          }
        }
      }
      output = [...response.items, ...output];
      if (offset >= response.pagination.totalItems) {
        dispatch(
          fetchScreenerSuccess(
            output,
            channel,
            response.pagination,
            participantPlansAndTickers,
            searchedPlanNumber,
            subPlanNumber
          )
        );
        dispatch(updateSort(sortingState, performanceQuarterly));
      }
    } catch (error) {
      dispatch(fetchScreenerFailure(error.message));
    }
  };
};

export const fetchDisclosuresBulkRequest = () => {
  return {
    type: FETCH_DISCLOSURES_BULK_REQUEST
  };
};

export const fetchDisclosuresBulkSuccess = data => {
  return {
    type: FETCH_DISCLOSURES_BULK_SUCCESS,
    payload: data
  };
};

export const fetchDisclosuresBulkFailure = error => {
  return {
    type: FETCH_DISCLOSURES_BULK_FAILURE,
    payload: error
  };
};

export const fetchDisclosuresBulk = (xidArray, service) => {
  return dispatch => {
    dispatch(fetchDisclosuresBulkRequest());
    getProfileFootnotesBulk({ xidArray, client: service })
      .then(result => {
        if (!result) {
          throw Error('No Profile Footnotes Bulk');
        }
        dispatch(fetchDisclosuresBulkSuccess(result));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchDisclosuresBulkFailure(errorMsg));
      });
  };
};
